// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/brain.js';

import { paths } from '../generated/brain';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('brain', Original, paths);
